import { pricesAPI } from "../../API/API";
import { SET_BOTH_CALENDAR, SET_PRICE_SUBSCRIBER, SET_PRICE_TYPE, UPDATE_PRICE_SUBSCRIBER } from "./constans";
import { updateSavingStatus } from "../../globalState/app/actions";


export const setPrice = (payload) => {
  return {
    type: SET_PRICE_SUBSCRIBER,
    payload
  }
};

export const updatePrice = (payload) => {
  return {
    type: UPDATE_PRICE_SUBSCRIBER,
    payload
  }
};

export const setPriceType = (room, priceType) => {
  return {
    type: SET_PRICE_TYPE,
    room,
    priceType
  }
};

export const setBothCalendar = () => {
  return {
    type: SET_BOTH_CALENDAR,
  }
};


export const filterMaxTypeSubscriberCalendar = (calendar) => {
  Object.keys(calendar).forEach(room => {
    let maxType = calendar[room].maxType
    let pricesRoom = calendar[room].prices

    if (pricesRoom) {
      Object.keys(pricesRoom).forEach(date => {
        pricesRoom[date] = pricesRoom[date].filter(item => item.type <= maxType || item.type === "child" || item.type === "additional")
      })
    }
  })

  return calendar
}

export const getPrices = (objectId) => async (dispatch) => {

  let response = await pricesAPI.getSubscriberList({ object: objectId });

  if (response.status) {
    dispatch(setPrice(filterMaxTypeSubscriberCalendar(response.data)))
  }
}


export const updaterPriceType = (room, priceType) => (dispatch) => {
  dispatch(setPriceType(room, priceType))
}


export const savePrices = (prices) => async (dispatch) => {
  dispatch(updateSavingStatus({ status: "loading" }))
  let response = await pricesAPI.updateSubscriber(prices);

  if (response.status) {
    dispatch(updatePrice(filterMaxTypeSubscriberCalendar(response.data)))
    dispatch(updateSavingStatus({ status: "success" }))
    return response.data
  } else {
    dispatch(updateSavingStatus({ status: "error", message: response.data.message }))
  }

}

export const clearCalendar = () => async (dispatch) => {
  dispatch(setBothCalendar())
}
